import { AddToCalendarText } from 'owa-locstrings/lib/strings/addtocalendartext.locstring.json';
import loc from 'owa-localize';
import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import {
    ActionMessageId,
    ActionType,
    AttachmentFullViewState,
    AttachmentMenuAction,
    getAddToCalendarEventEstimateCompleteTimeInMS,
    setActionCompletePercent,
    startFakeProgressIndicator,
} from 'owa-attachment-full-data';
import addCalendarEventsAttachment from 'owa-attachment-full-data/lib/actions/addCalendarEventsAttachment';
import setOngoingActionAndActionMessage from 'owa-attachment-full-data/lib/actions/setOngoingActionAndActionMessage';
import AddToCalendarSource from 'owa-attachment-full-data/lib/schema/AddToCalendarSource';
import AddToCalendarActionSource from 'owa-attachment-full-view/lib/types/ActionSource';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import AttachmentClass from 'owa-attachment-model-store/lib/store/schema/AttachmentClass';
import getAttachmentFileType from 'owa-attachment-model-store/lib/utils/getAttachmentFileType';
import isMenuActionSupported from '../../utils/isMenuActionSupported';

export function addToCalendar(attachment: AttachmentFullViewState, actionSource: string) {
    const attachmentModel = getAttachment(attachment.attachmentId);
    const fileType = getAttachmentFileType(attachmentModel);
    const maxFileSizeInBytes = 10 * 1024 * 1024; // Maximum file size limit i.e. 10MB

    logUsage('AddToCalendar', [actionSource], {
        cosmosOnlyData: JSON.stringify({ size: attachmentModel.model.Size, fileType: fileType }),
    });

    if (
        attachmentModel.model.Size > maxFileSizeInBytes ||
        !attachment.attachmentId ||
        !attachment.attachmentId.Id
    ) {
        setOngoingActionAndActionMessage(
            attachment,
            ActionType.None,
            ActionMessageId.ImportToCalendarFailedWithIcon
        );
    } else {
        startFakeProgressIndicator(
            getAddToCalendarEventEstimateCompleteTimeInMS(attachmentModel.model.Size),
            0.1,
            (completePercent: number) => {
                setActionCompletePercent(attachment, completePercent);
            },
            attachment.attachmentId
        );
        addCalendarEventsAttachment(attachment, AddToCalendarSource.AttachmentDropDown);
    }
}

export default function addCalendarEventsAttachmentContextItemBuilder(
    attachment: AttachmentFullViewState
): IContextualMenuItem {
    const attachmentModel = getAttachment(attachment.attachmentId);
    if (
        !isMenuActionSupported(AttachmentMenuAction.ImportCalendarEventAttachment, attachment) ||
        !attachmentModel ||
        attachmentModel.attachmentClass !== AttachmentClass.CalendarEvent
    ) {
        return null;
    }

    return {
        name: loc(AddToCalendarText),
        key: 'AddToCalendar',
        onClick: () => {
            addToCalendar(attachment, AddToCalendarActionSource.ContextMenu);
        },
    };
}
